import React, { FC, useMemo } from 'react';
import { Thing } from 'schema-dts';

export type JsonLdProps = {
  id?: string;
  key?: string;
  value: Thing;
};

const JsonLd: FC<JsonLdProps> = ({ value, id, key }) => {
  const data = useMemo(() => ({ __html: JSON.stringify(value) }), [value]);

  return (
    <script
      key={key}
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={data}
    />
  );
};

export default JsonLd;
